module.exports = __webpack_public_path__ + "img/gongshui-3.356abaf1.png";